import React, { useState } from "react";
import { upsconverter } from "../helperFunctions/helperFunctions";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";

export default function Votes({ score }) {
  const [upVote, setUpVote] = useState(false);
  const [downVote, setDownVote] = useState(false);

  function handleUpVote() {
    setUpVote(!upVote);
    setDownVote(false);
  }
  function handleDownVote() {
    setDownVote(!downVote);
    setUpVote(false);
  }

  return (
    <div className="col-1 d-flex flex-column align-items-center ps-3 mt-3">
      <FaChevronUp
        className={upVote ? "chevron up" : "chevron"}
        onClick={() => handleUpVote()}
      />

      <p className="votes">{upsconverter(score)}</p>
      <FaChevronDown
        className={downVote ? "chevron down" : "chevron"}
        onClick={() => handleDownVote()}
      />
    </div>
  );
}
